/*
 *
 * NotificationEngine actions
 *
 */

import {
  SHOW_NOTIFICATION, DISMISS_NOTIFICATION,
} from './constants';

export function showNotification(id, nType, message, timeout, isDismissable, onClickAction, onDismissAction) {
  return {
    type: SHOW_NOTIFICATION,
    id,
    nType,
    message,
    timeout,
    onClickAction,
    onDismissAction,
  };
}

export function dismissNotification(id) {
  return {
    type: DISMISS_NOTIFICATION,
    id,
  };
}
